import useAxios from '../../../library/axios'; 

import IGroupPolicy from '../model/GroupPolicy';

const _ = () => {

    const axios = useAxios();    

    const getGroupPoliciesList = async () : Promise<IGroupPolicy[]>  => {        
        const {data} = (await axios.get('/crm/groupPolicy/getGroupPoliciesList'));
        
        return await data;
      }

    const getUserGroupPoliciesList = async ()  => {
        const {data} = (await axios.get('/crm/groupPolicy/getUserGroupPoliciesList'));
        return await data;
      }

    const getAgenciesList = async ()  => {
        const {data} = (await axios.get('/crm/groupPolicy/getAgenciesList'));
        return await data;
    }

    const getUserAgenciesList = async ()  => {
        const {data} = (await axios.get('/crm/groupPolicy/getUserAgenciesList'));
        return await data;
    }

    const getGroupPolicyProductsList = async ()  => {
        
        const {data} = (await axios.get('/crm/groupPolicy/getGroupPolicyProductsList'));
        return await data;
    }

    const getUserGroupPolicyProductsList = async ()  => {
        
        const {data} = (await axios.get('/crm/groupPolicy/getUserGroupPolicyProductsList'));
        return await data;
    }

    return {
                
        getGroupPoliciesList, getUserGroupPoliciesList, 
        getAgenciesList, getUserAgenciesList,

        getGroupPolicyProductsList, getUserGroupPolicyProductsList  
      
    } 
}

export default _;